class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.hasAttribute("open")&& this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() { 
    super();
    this.detailsHeaderMenu = this.querySelector('#Details-HeaderMenu-');
    this.mainMenuItem = this.querySelector('.header__menu-item');
    this.contentMenu = this.querySelector('.mega-menu__content');

    if (this) {
      this.addEventListener('mouseover', this.onMouseOver.bind(this));
      this.addEventListener('mouseout', this.onMouseOut.bind(this));
  }
}

 onMouseOver() {
  /* && -> Serviva perché va in conflitto con il megamenu */
  this.detailsHeaderMenu && this.detailsHeaderMenu.setAttribute("open", "");
    if(this.contentMenu){
      this.contentMenu.classList.remove("hidden");
      this.setAttribute('open','')
    }
}


 onMouseOut() {
  /* && -> Serviva perché va in conflitto con il megamenu */
  this.detailsHeaderMenu && this.detailsHeaderMenu.removeAttribute("open");
  if(this.contentMenu){
    this.contentMenu.classList.add("hidden");
    this.removeAttribute('open')
  }
 }

 close(){
    this.onMouseOut.bind(this)
 }

/*   onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  } */
}

customElements.define('header-menu', HeaderMenu);
